import type { PiniaPluginContext, Store } from "pinia";

import { isNonPrimitive } from "@/utils/record";
import type { UnknownRecord } from "@/utils/type";

const stores = new Array<Store>();

export function storesPlugin(context: PiniaPluginContext) {
  stores.push(context.store);
}

export function storesLen(excludes: string[] = []) {
  let len = 0;
  for (const store of stores) {
    if (!excludes.includes(store.$id)) {
      for (const prop in store.$state) {
        const entry = (store.$state as UnknownRecord)[prop];
        if (entry !== null && entry !== undefined) {
          if (Array.isArray(entry)) {
            len += entry.length;
          } else if (isNonPrimitive(entry)) {
            len += Object.keys(entry).length;
          } else {
            len++;
          }
        }
      }
    }
  }
  return len;
}
